module.exports = __webpack_public_path__ + "img/photo-01.96944649.jpg";